<template>
  <div class="flex flex-shrink-0 justify-end">
    <span
      role="button"
      @click="close"
    >
      <IconCross
        width="20px"
        height="20px"
        stroke="white"
      />
    </span>
  </div>
</template>

<script>
import store from '@/components/facet/store'
import IconCross from '@/assets/icons/icon-cross.svg'

export default {
  components: {
    IconCross
  },
  methods: {
    close() {
      store.dispatch('setAllFiltersVisibility', { value: false })
    }
  }
}
</script>
